export default __webpack_public_path__ + "static/media/correct-copy-2.488f6215.svg";